import * as identityStore from '../identity';
import * as coreStore from '../store';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { filter, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(private store: Store, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store.pipe(
      select(identityStore.selectIdentityAccount(coreStore.selectIdentityState)),
      filter(account => !!account),
      map(account => {
        const userRoles = account?.idTokenClaims?.roles;

        if (!userRoles) {
          return false;
        }

        const allowedRoles = next.data.roles;
        const matchingRoles = userRoles.filter(x => allowedRoles.includes(x));

        if (matchingRoles.length > 0) {
          return true;
        } else {
          this.router.navigate(['/sessions/403']);
          return false;
        }
      })
    );
  }
}
